import { useToast } from '@common/hooks';
import { useMutation } from '@tanstack/react-query';
import { AuthMutation } from '@/api';
import { WEL_MARKET_ROUTES } from '@/constants/routes';
import { useCustomRouter } from '@/hooks/useCustomRouter';
export const useCartOrder = () => {
  const router = useCustomRouter();
  const {
    toast
  } = useToast();
  const createBeforeOrderMutation = useMutation({
    ...AuthMutation['post:/wello/v2/auth/local-market/before-orders']()
  });
  const createBeforeOrderAndNavigate = async (cartItemIds: string[]) => {
    if (cartItemIds.length === 0) return;
    try {
      const result = await createBeforeOrderMutation.mutateAsync({
        body: {
          cartItemIds
        }
      });
      const beforeOrderId = result?.context?.beforeOrderId;
      if (beforeOrderId) {
        router.push(WEL_MARKET_ROUTES.ORDER.pathname({
          beforeOrderId
        }));
      }
    } catch {
      toast({
        message: '주문 준비에 실패했어요. 다시 시도해주세요.',
        type: 'fail'
      });
    }
  };
  return {
    createBeforeOrderAndNavigate,
    isCreatingOrder: createBeforeOrderMutation.isPending
  };
};